import { Step, StepButton, Stepper, useTheme } from '@mui/material';
import React from 'react';

interface Props {
  activeStep: number;
}

const steps = ['Overview', 'Feed programs', 'Finance', 'Review and run'];

const StepsSideBar: React.FC<Props> = ({ activeStep }) => {
  const theme = useTheme();
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((step) => (
        <Step key={step} completed={Number(step) < activeStep}>
          <StepButton
            disabled
            sx={{
              // #TODO: WIP
              // ----- Label (text to the right) should be white across states -----
              '& .MuiStepLabel-label': { color: '#fff' },
              '&.Mui-disabled .MuiStepLabel-label': { color: '#fff', opacity: 0.5 },
              '& .MuiStepLabel-label.Mui-active': { color: '#fff', opacity: 1 },

              // ----- Default StepIcon (SVG) base -----
              // Non-active (includes default, completed, disabled): transparent circle, white number
              '& .MuiStepIcon-root': {
                color: 'transparent', // affects circle via currentColor
                opacity: 0.5, // dim non-active steps
                overflow: 'visible',
                '& circle': { stroke: 'white', strokeWidth: 0.75 },
              },
              '& .MuiStepIcon-text': {
                fill: '#fff',
                color: '#fff',
              },

              // ----- Active: white circle, transparent number -----
              '& .MuiStepIcon-root.Mui-active': {
                color: '#fff',
                opacity: 1,
                '& circle': { fill: '#fff' },
              },
              '& .MuiStepIcon-root.Mui-active + .MuiStepIcon-text, & .MuiStepIcon-root.Mui-active ~ .MuiStepIcon-text': {
                // (safety: text is a child, so the rule below already covers it)
              },
              '& .MuiStepIcon-root.Mui-active .MuiStepIcon-text, & .MuiStepIcon-text.Mui-active': {
                fill: theme.palette.darkBlue.main,
                color: theme.palette.darkBlue.main,
              },
            }}>
            {step}
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default StepsSideBar;
